var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDireccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7695 1.00195C9.50978 1.49413 5.91212 4.29491 4.4297 8.27343C3.89064 9.7207 3.72657 10.8281 3.76759 12.6269C3.82032 14.5664 4.12501 15.9844 4.89259 17.8769C6.41017 21.5976 9.65626 25.4648 13.7051 28.3828C14.5371 28.9805 14.8008 29.1035 15.1406 29.0391C15.4688 28.9746 16.5938 28.1836 17.9004 27.0937C22.5938 23.1914 25.5059 18.5332 26.1035 13.9746C26.2207 13.0664 26.2207 11.3555 26.1035 10.582C25.8164 8.70116 25.0899 6.94335 23.9707 5.44921C23.5664 4.90429 22.6055 3.9082 22.0606 3.45702C19.7988 1.60546 16.6524 0.67382 13.7695 1.00195ZM16.2188 6.73827C18.0645 7.25976 19.459 8.90624 19.6172 10.7519C19.8281 13.1016 18.4395 15.1289 16.1895 15.7734C15.5391 15.9609 14.4024 15.9609 13.752 15.7734C12.2168 15.334 11.0684 14.25 10.5234 12.7266C10.3477 12.2344 10.3418 12.1816 10.3418 11.25C10.3418 10.3184 10.3477 10.2656 10.5234 9.77343C11.127 8.08593 12.4746 6.94335 14.2266 6.62109C14.6719 6.53905 15.7383 6.59765 16.2188 6.73827Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireccion);
export default __webpack_public_path__ + "static/media/direccion.aba9f326cdc587b2537ff3b2a37f2430.svg";
export { ForwardRef as ReactComponent };